module.exports = __webpack_public_path__ + "img/gxlogo7.7ef6f2c8.png";